define.alias("shared/utils/formatters/create-formatted-industry-hashtags", "settings/utils/formatters/create-formatted-industry-hashtags");